import i18n from "i18next";

export const optionalNonNegativeValidator = (_: unknown, value: unknown) => {
    // Allow undefined/empty as valid
    if (value === undefined || value === null || value === "") return Promise.resolve();
    const num = typeof value === "number" ? value : Number(value);
    if (!Number.isFinite(num) || num < 0) return Promise.reject(new Error(i18n.t("common.input.positiveNumber.error")));
    return Promise.resolve();
};

export const blankToUndefined = (e: unknown) => {
    // AntD passes either raw value or event
    if (typeof e === "number") return e;
    if (e && typeof e === "object" && "target" in (e as Record<string, unknown>)) {
        const v = (e as { target?: { value?: unknown } }).target?.value;
        return v === "" ? undefined : v;
    }
    return e;
};
